import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const Wrapper = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-direction: column;
    height: 100%;
    color: ${({ theme }) => theme.colors.greys[800]};

    .note {
        margin: 24px 0;
        font-weight: 400;
        font-size: var(--font-size-s);
        line-height: 17px;
    }
`

export const Body = styled('div')`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    overflow-y: auto;
`

export const drawerScrollFixStyles = {
    '.cc-drawer-body:has(.add-technologies-drawer)': { minHeight: 0 },
    '.cc-drawer-content:has(.add-technologies-drawer)': { minHeight: 0 },
}

export const Footer = styled('div')<{ theme?: TTheme }>`
    display: flex;
    flex-shrink: 0;
    position: sticky;
    bottom: 0;
    z-index: 1;
    justify-content: flex-end;
    align-items: center;
    padding: 36px 0 0;
    background-color: ${({ theme }) => theme.colors.semantic.drawerBackground};
    border-top: 1px solid
        ${({ theme }) => theme.colors.semantic.drawerSeparator};
    .action-button {
        width: 100px;
        margin-bottom: 24px;
    }
`
